<template>
  <div class="addressPTPost-div">
    <h3 class="mb-3 h-style">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path fill="none" stroke="#545454" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M7 6H5m2 3H5m2 3H5m2 3H5m2 3H5m11-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2M7 3h11a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m8 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0" /></svg>
      <span>담당자 등록</span>
    </h3>
    <v-form ref="ptAddressEmailFrm" lazy-validation>
      <div class="post-contents">
        <ul class="post__box">
          <li class="post__list border-bottom-none">
            <SignupInput class="error-text-none" placeholder="" label="이름*" type="text" v-model="param.name" required :rules="[this.validSet.empty(param.name, '')]" :maxlength="30" />
          </li>
          <li class="post__list border-bottom-none">
            <SignupInput class="error-text-none" placeholder="" label="이메일*" type="text" v-model="param.email" required :rules="[this.validSet.email]" />
          </li>
        </ul>
      </div>
    </v-form>
    <div class="wrapper wrapper-post-btn">
      <div class="btn-box mt-2">
        <div class="post-btn">
          <v-btn class="btn-cancle" elevation="0" @click="closeModal">취소</v-btn>
        </div>
        <div class="post-btn">
          <v-btn class="btn-confim" elevation="0" @click="onApprove">저장</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import validSet from '@/assets/valid';
import SignupInput from '@/views/member/SignUpInput.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'PTAddressEmail',
  data() {
    return {
      validSet,
      param: {
        name: '',
        email: '',
      },
    };
  },
  components: {
    SignupInput,
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP']),
    valid() {
      return this.$refs.ptAddressEmailFrm.validate();
    },
    onApprove() {
      if (this.valid()) {
        const message = '담당자가 저장 되었습니다';
        this.SET_POPUP({
          title: '알림',
          text: message,
          width: 300,
        });
        this.$emit('approveEmail', this.param);
        this.closeModal();
      }
    },
    reset() {
      this.param = {
        name: '',
        email: '',
      };
    },
    closeModal() {
      this.reset();
      this.$emit('closeModal');
    },
  },
};
</script>
<style lang="scss">
// PTAddressPost.vue와 동일한 스타일 사용
</style>
